import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import layoutComponentsDictionary from "./layout/layoutComponentsDictionary";
import logger from "js-logger";
import React from "react";
export var BasicComponents = function (_a) {
    var layoutName = _a.layoutName, packageName = _a.packageName, moduleName = _a.moduleName, layoutType = _a.layoutType, onHandleUpdate = _a.onHandleUpdate, validations = _a.validations, isStudioField = _a.isStudioField, isSelected = _a.isSelected, layoutParent = _a.layoutParent, viewScreen = _a.viewScreen, meta = _a.meta, fieldDefs = _a.fieldDefs, record = _a.record;
    var componentIndex = 0;
    if (layoutType) {
        var componentName = layoutType || "";
        var layoutComponentSettings = layoutComponentsDictionary.getLayoutComponent("".concat(componentName));
        if (layoutComponentSettings) {
            logger.debug("[LAYOUT SETTINGS] - Utilisation du composant \"".concat(layoutComponentSettings.name, "\" pour afficher le settings du type \"").concat(componentName, "\"."));
            return React.createElement(layoutComponentSettings, {
                key: "element_basic_".concat(componentIndex++),
                moduleName: moduleName,
                layoutName: layoutName,
                packageName: packageName,
                meta: meta,
                onHandleUpdate: onHandleUpdate,
                validations: validations,
                isStudioField: isStudioField,
                isSelected: isSelected,
                layoutParent: layoutParent,
                viewScreen: viewScreen,
                fieldDefs: fieldDefs,
                record: record,
            });
        }
    }
    return _jsx(_Fragment, {});
};
